import AITopBanner from '@components/Banner/AITopBanner';
import { PrimaryButton, SecondaryButton } from '@components/Button/variants';
import Byline from '@components/Byline';
import BylineWithHeadshot from '@components/BylineWithHeadshot';
import CookiesSettingsBtn from '@components/CookiesSettingsBtn';
import CustomToaster from '@components/CustomToaster';
import EmailConfirmation from '@components/EmailConfirmation/index';
import EmailLeadCaptureWithQueryClientWrapper from '@components/EmailLeadCapture/EmailLeadCaptureWithQueryClientWrapper';
import EnableProfileModal from '@components/EnableProfileModal/index';
import EventFollowBanner from '@components/Events/EventFollowBanner/index';
import BannerAdvertisement from '@components/FeaturedPartnerAd/Banner';
import FollowButtonWithQueryClientWrapper from '@components/FollowButton/FollowButtonWithQueryClientWrapper';
import Footer from '@components/Footer/index';
import FieldLabel from '@components/Form/FieldLabel';
import HorizontalLogoDivider from '@components/HorizontalLogoDivider';
import IconClose from '@components/Images/Rebranding/IconClose';
import IconFacebook from '@components/Images/Rebranding/IconFacebook';
import IconOrgChart from '@components/Images/Rebranding/IconOrgChart';
import IconProTagArticle from '@components/Images/Rebranding/IconProTagArticle';
import IconTI from '@components/Images/Rebranding/IconTI';
import IconTheWeekend from '@components/Images/Rebranding/IconTheWeekend';
import IconThreads from '@components/Images/Rebranding/IconThreads';
import IconX from '@components/Images/Rebranding/IconX';
import LogoTIProWithIconTI from '@components/Images/Rebranding/LogoTIProWithIconTI';
import LogoTIWithIconTI from '@components/Images/Rebranding/LogoTIWithIconTI';
import MarketingModal from '@components/MarketingModal/index';
import MessageUserButton from '@components/MessageUserButton/index';
import SlimNav from '@components/Nav/SlimNav';
import Nav from '@components/Nav/index';
import NewsletterFeedBanner from '@components/Newsletter/NewsletterFeedBanner/index';
import MarketingLeadCaptureWithApple from '@components/OAuthButtons/MarketingLeadCaptureWithApple';
import MarketingLeadCaptureWithGoogle from '@components/OAuthButtons/MarketingLeadCaptureWithGoogle';
import ProExclusiveLogo from '@components/ProExclusiveLogo/index';
import AIDataCenterDatabase from '@components/Project/AIDataCenterDatabase';
import SportsStreamingDatabase from '@components/Project/SportsStreamingDatabase';
import TI50 from '@components/Project/TI50';
import TechIPOTracker from '@components/Project/TechIPOTracker';
import TechSentimentTracker from '@components/Project/TechSentimentTracker';
import TeslaDiasporaDatabase from '@components/Project/TeslaDiasporaDatabase';
import Top50Influential from '@components/Project/Top50Influential';
import ProjectTitle from '@components/ProjectTitle/index';
import ProjectsPaywall from '@components/ProjectsPaywall/index';
import ScoopsPage from '@components/Scoops/index';
import SocialLinks from '@components/SocialLinks/index';
import CustomSpinner from '@components/Spinner/CustomSpinner';
import StickyBannerBottom from '@components/StickyBanner/Bottom';
import StickyBannerTop from '@components/StickyBanner/Top';
import StickyBannerUserStatus from '@components/StickyBanner/Top/UserStatus';
import TIHeader from '@components/TIHeader';
import TITVPopout from '@components/TITVPopout/index';
import TopicDescription from '@components/Topic/TopicDescription/index';
import TopicFollowAndTagModal from '@components/Topic/TopicFollowAndTagModal/index';
import UpdateProfileModal from '@components/UpdateProfileModal/index';
import UserOnboardingModal from '@components/UserOnboardingModal/index';
import UserOnboardingTooltip from '@components/UserOnboardingTooltip/index';
import ViewInAppModal from '@components/ViewInAppModal/index';
import AIDeepResearch from '@components/pages/AI/DeepResearch/index';
import AIDeepResearchSettings from '@components/pages/AI/DeepResearchSettings/index';
import AsiaTechCoverage from '@components/pages/AsiaTechCoverage/index';
import Blueprint from '@components/pages/Blueprint/index';
import Bookmarks from '@components/pages/Bookmarks/index';
import CorporateLanding from '@components/pages/CorporateLanding/index';
import CryptoPowerlist from '@components/pages/CryptoPowerlist/index';
import DualSubscribe from '@components/pages/DualSubscribe/index';
import EnterprisePowerlistHeader from '@components/pages/EnterprisePowerlist/Header';
import EnterprisePowerlist from '@components/pages/EnterprisePowerlist/index';
import EventInfo from '@components/pages/EventInfo';
import EventShowPage from '@components/pages/Events/EventShowPage/index';
import EventsLanding from '@components/pages/EventsLanding/index';
import FinancialCoverage from '@components/pages/FinancialCoverage/index';
import ForYou from '@components/pages/ForYou/index';
import TopicForumPosts from '@components/pages/Forum/TopicForumPosts/index';
import FreeProTrial from '@components/pages/FreeProTrial/index';
import Gift from '@components/pages/Gift/index';
import GiftLandingForLead from '@components/pages/GiftLandingForLead/index';
import GiftPaymentConfirmation from '@components/pages/GiftPaymentConfirmation/index';
import GraphicsPage from '@components/pages/Graphics/GraphicsPage/index';
import GraphicsSearchPage from '@components/pages/Graphics/SearchPage/index';
import Highlight from '@components/pages/Highlight';
import NewsletterIndexLanding from '@components/pages/NewsletterIndexLanding/index';
import NewsletterLanding from '@components/pages/NewsletterLanding/index';
import OrgChartCompanyPage from '@components/pages/OrgCharts/OrgChartCompanyPage/index';
import OrgCharts from '@components/pages/OrgCharts/index';
import OrgSignUp from '@components/pages/OrgSignUp/index';
import PageTemplates from '@components/pages/PageTemplates/index';
import Partners from '@components/pages/Partners';
import ProCluster from '@components/pages/Pro/Cluster';
import ProMarketingCTAs from '@components/pages/Pro/ProMarketingCTAs';
import Pro from '@components/pages/Pro/index';
import Project from '@components/pages/Project/index';
import ReadUsFirst from '@components/pages/ReadUsFirst/index';
import ReferralLanding from '@components/pages/Referral/Landing/index';
import SearchPage from '@components/pages/SearchPage/index';
import SettingsUserProfile from '@components/pages/Settings/UserProfile/index';
import SharePersonalBriefing from '@components/pages/SharePersonalBriefing/index';
import SubscribeTest from '@components/pages/SubscribeTest/index';
import {
  SubscriberProfileSPA,
  SubscriberProfileServer,
} from '@components/pages/SubscriberProfile/index';
import SubscriptionLanding from '@components/pages/SubscriptionLanding/index';
import TITVEpisode from '@components/pages/TITV/Episode/index';
import TITVMultistreamFeature from '@components/pages/TITV/MultistreamFeature/index';
import TITVNetwork from '@components/pages/TITV/Network/index';
import TITV from '@components/pages/TITV/index';
import SubscriptionTeam from '@components/pages/Team/index';
import VideoUploadPage from '@components/pages/VideoUpload';
import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

registerWithErrorBoundary({
  AITopBanner,
  AIDataCenterDatabase,
  AIDeepResearch,
  AIDeepResearchSettings,
  AsiaTechCoverage,
  BannerAdvertisement,
  Bookmarks,
  Blueprint,
  Byline,
  BylineWithHeadshot,
  CookiesSettingsBtn,
  CorporateLanding,
  CryptoPowerlist,
  CustomSpinner,
  CustomToaster,
  DualSubscribe,
  EmailConfirmation,
  EmailLeadCaptureWithQueryClientWrapper,
  EnableProfileModal,
  EnterprisePowerlist,
  EnterprisePowerlistHeader,
  EventFollowBanner,
  EventInfo,
  EventShowPage,
  EventsLanding,
  FieldLabel,
  FinancialCoverage,
  FollowButtonWithQueryClientWrapper,
  Footer,
  ForYou,
  FreeProTrial,
  Gift,
  GiftLandingForLead,
  GiftPaymentConfirmation,
  GraphicsPage,
  GraphicsSearchPage,
  Highlight,
  HorizontalLogoDivider,
  IconClose,
  IconFacebook,
  IconOrgChart,
  IconProTagArticle,
  IconTheWeekend,
  IconThreads,
  IconTI,
  IconX,
  LogoTIProWithIconTI,
  LogoTIWithIconTI,
  MarketingLeadCaptureWithApple,
  MarketingLeadCaptureWithGoogle,
  MarketingModal,
  MessageUserButton,
  Nav,
  NewsletterFeedBanner,
  NewsletterIndexLanding,
  NewsletterLanding,
  OrgCharts,
  OrgChartCompanyPage,
  OrgSignUp,
  PageTemplates,
  Partners,
  PrimaryButton,
  Pro,
  ProCluster,
  ProExclusiveLogo,
  Project,
  ProjectsPaywall,
  ProjectTitle,
  ProMarketingCTAs,
  ReadUsFirst,
  ReferralLanding,
  ScoopsPage,
  SearchPage,
  SecondaryButton,
  SettingsUserProfile,
  SharePersonalBriefing,
  SlimNav,
  SocialLinks,
  SportsStreamingDatabase,
  StickyBannerBottom,
  StickyBannerTop,
  StickyBannerUserStatus,
  SubscriberProfileServer,
  SubscriberProfileSPA,
  SubscribeTest,
  SubscriptionLanding,
  TITV,
  TITVEpisode,
  TITVMultistreamFeature,
  TITVNetwork,
  TITVPopout,
  SubscriptionTeam,
  VideoUploadPage,
  TechIPOTracker,
  TechSentimentTracker,
  TeslaDiasporaDatabase,
  TI50,
  Top50Influential,
  TIHeader,
  TopicDescription,
  TopicFollowAndTagModal,
  TopicForumPosts,
  UpdateProfileModal,
  UserOnboardingModal,
  ViewInAppModal,
  UserOnboardingTooltip,
});
